// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__Ubqcb","menuItems":"Menu_menuItems__k3Zuf","active":"Menu_active__3tgsr"};